export default __webpack_public_path__ + "static/media/minus.c2bca677.svg";